import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress,  Box, Typography, DialogContentText,  Button  } from '@mui/material';
import axios from 'axios';
import Cookies from 'js-cookie'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function CreateCouponDialog({ open, handleClose,couponToDelete }) {
   
    const [showSpinner, setShowSpinner] = useState(false);

    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })



    const onDeleteWoo = () => {
 
        setShowSpinner(true);
        let Tmp = {deleteId: couponToDelete.deleteId,coupon_code: couponToDelete.coupon_code};

        MyAxios.post(process.env.REACT_APP_API + '/woo/deleteCoupon/',Tmp)              
        .then((res) => {       
                console.log(res)
                setShowSpinner(false);
                if(res.status === 200)    
                {
                    alert("Sauvegarde complété")
                    handleClose();
                }                   
                else      
                    alert("Erreur sauvegarde") 
                
            })
            .catch((error) => {
                console.log(error)
                alert("Erreur sauvegarde")
            });





        
    };

    return (
         <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                <WarningAmberIcon sx={{ color: 'orange', marginRight: '8px' }} />
                <Typography variant="h6">
                    Confirmer la suppression du coupon
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ marginBottom: 2 }}>
                    Voulez-vous vraiment supprimer ce coupon ? 
                    ( Il sera également retiré des trimestres qui l'utilise.)
                </DialogContentText>
            </DialogContent>

            <Box sx={{ padding: '16px' }}>                                
                <Button
                    onClick={onDeleteWoo}
                    color="error"
                    startIcon={<DeleteIcon />}
                    variant="containedFifth"
                    fullWidth
                >
                    Supprimer de WooCommerce et des trimestres qui l'utilise
                  
                </Button>
            </Box>
            {showSpinner ?
                <Box sx={{ padding: '16px' }} 
                    
                        display="flex"
                        justifyContent="center"
                        alignItems="center">                                
                
                    Communication avec InterOFC...
                        <CircularProgress />
                
                </Box>
            : null}

            <Box sx={{ padding: '16px' }}>
                <Button
                    onClick={() => {setShowSpinner(false); handleClose(); }}
                    color="primary"
                    variant="containedFifth"
                    fullWidth
                    sx={{
                        backgroundColor: '#1976d2', // Bleu
                        '&:hover': { backgroundColor: '#115293' }, // Bleu plus foncé au hover
                    }}
                >
                    Annuler
                </Button>
            </Box>
        </Dialog>
    );
}
